import React, { useRef } from 'react';
import { theme } from '../theme';
import { Text } from '../Text';
import styled from 'styled-components';
export function BadgeFallbackImage({ title }) {
    const bgColour = useRef(fallbackBackgroundColours[Math.floor(Math.random() * fallbackBackgroundColours.length)]);
    return (React.createElement(StyledFallbackImage, { "$backgroundColour": bgColour.current },
        React.createElement(Text, { typo: "caption", color: "liquorice", style: { fontWeight: 'bold' } }, title?.substring(0, 2) ?? null)));
}
const fallbackBackgroundColours = [
    theme.colors.lollipop,
    theme.colors.marshmallowPink,
    theme.colors.bubblegum,
    theme.colors.fairyFloss,
];
const StyledFallbackImage = styled.div `
  background-color: ${(props) => props.$backgroundColour};
  display: flex;
  place-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;
//# sourceMappingURL=BadgeFallbackImage.js.map